import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Paper, useTheme } from '@mui/material';
import { Home as HomeIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';

export default function NotFound() {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: 3,
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, #0f0a1e 0%, #1a1429 100%)'
          : 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 5,
          borderRadius: 4,
          maxWidth: 500,
          width: '100%',
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: '6rem',
            fontWeight: 'bold',
            background: 'linear-gradient(90deg, #ff5b8d 0%, #7952f6 100%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            mb: 2,
          }}
        >
          404
        </Typography>
        
        <Typography variant="h4" component="h2" fontWeight="bold" sx={{ mb: 2 }}>
          Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </Typography>
        
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            component={Link}
            to="/"
            variant="contained"
            startIcon={<HomeIcon />}
            sx={{
              background: 'linear-gradient(90deg, #ff5b8d 0%, #7952f6 100%)',
              '&:hover': {
                background: 'linear-gradient(90deg, #ff4b7d 0%, #6942e6 100%)',
              },
            }}
          >
            Go to Dashboard
          </Button>
          
          <Button
            onClick={() => window.history.back()}
            variant="outlined"
            startIcon={<ArrowBackIcon />}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}